/*
 * popupReducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 30-Sep-2024
 */

import produce from 'immer'
import { actionTypes } from '../actions/popup'

const ACTION_HANDLERS = {
  [actionTypes.FLOW_POPUP]: produce((draft, action) => {
    const nextPopup = action?.popup || ''

    if (nextPopup === 'EXTEND_SESSION' && draft.flowPopup === 'EXTEND_SESSION') return

    if (nextPopup === 'EXTEND_SESSION' && draft.flowPopup && draft.flowPopup !== 'EXTEND_SESSION') {
      draft.suspendedFlowPopup = draft.flowPopup
      draft.flowPopup = nextPopup
      return
    }

    if (!nextPopup && draft.flowPopup === 'EXTEND_SESSION' && draft.suspendedFlowPopup) {
      draft.flowPopup = draft.suspendedFlowPopup
      draft.suspendedFlowPopup = ''
      return
    }

    draft.flowPopup = nextPopup
    draft.popupData = action?.moreInfo
    draft.suspendedFlowPopup = ''
  })
  // @generator reducer:type:action

}

// The initial state of the popup
const initialState = {
  flowPopup: '',
  popupData: {},
  suspendedFlowPopup: ''
}

const popup = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default popup
